"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = void 0;
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const index_1 = require("../../index");
const Tab = (props) => {
    const minWidthForCloseButton = 90;
    const { title, active, route, isDynamicTab, index, maxWidth, tabsLength } = props;
    const showCloseButton = isDynamicTab && tabsLength > 1 && (maxWidth > minWidthForCloseButton || active);
    const paddingLeft = isDynamicTab && showCloseButton ? maxWidth < 100 ? maxWidth / 8 : 25 : undefined;
    const paddingRight = isDynamicTab && showCloseButton ? maxWidth > 100 ?
        14 : maxWidth / 10 : undefined;
    const marginLeft = maxWidth > 100 ? 11 : maxWidth / 50;
    const ref = react_1.useRef(null);
    props.setTabRef(ref);
    const tabClasses = classnames_1.default({
        'active': active ? 'isActive' : '',
        'dynamic-tab': isDynamicTab,
        'tab-button': true,
    });
    return (React.createElement(react_router_dom_1.Link, { to: route, className: tabClasses, id: `tab_${title}_${index}`, key: `tab_${title}_${index}`, role: "tab", "aria-selected": active, "aria-controls": `tabpanel_${title}`, innerRef: ref, style: { maxWidth: isDynamicTab ? maxWidth : undefined, paddingLeft, paddingRight } },
        React.createElement(React.Fragment, null,
            props.icon && React.createElement(index_1.Icon, { className: 'tab-icon', icon: props.icon }),
            React.createElement("div", { className: 'tab-title' }, title)),
        showCloseButton &&
            React.createElement("div", { onClick: () => props.closeTab(index), className: "close-tab-cross", style: { marginLeft } },
                React.createElement(index_1.Icon, { icon: "cross_grey" }))));
};
exports.Tab = Tab;
//# sourceMappingURL=Tab.js.map